import { isEmptyString, stripNonNumeric } from '../../../core/util/string';
import { isValidPhone } from '../../../core/util/phoneNumber';

export const phoneNumberValidator = (rule, rawValue, callback) => {
  const value = stripNonNumeric(String(rawValue));
  if (isEmptyString(value)) {
    return callback('Required');
  } else if (!isValidPhone(value)) {
    return callback('Invalid phone number');
  }

  return callback();
};
